import React from 'react';
import { UsersIcon, ServerIcon, HardDriveIcon, MailIcon, NetworkIcon } from 'lucide-react';
export function Changes() {
  return <section id="änderungen" className="py-16 bg-gray-50" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="text-center" data-id="element-64">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-65">
            Was sich ändert
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-66">
            Die neuen Anforderungen 2025/26 im Detail
          </p>
        </div>
        <div className="mt-12 space-y-12" data-id="element-67">
          {/* Personal & Schulung */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-68">
            <div className="p-6" data-id="element-69">
              <div className="flex items-center" data-id="element-70">
                <div className="flex-shrink-0" data-id="element-71">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600" data-id="element-72">
                    <UsersIcon className="h-6 w-6" data-id="element-73" />
                  </div>
                </div>
                <h3 className="ml-4 text-xl font-medium text-gray-900" data-id="element-74">
                  Personal & Schulung
                </h3>
              </div>
              <div className="mt-4 text-gray-600" data-id="element-75">
                <ul className="space-y-3" data-id="element-76">
                  <li className="flex items-start" data-id="element-77">
                    <span className="text-blue-600 mr-2" data-id="element-78">•</span>
                    <span data-id="element-79">
                      Pflicht zur strukturierten Einarbeitung neuer
                      Mitarbeitender
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-80">
                    <span className="text-blue-600 mr-2" data-id="element-81">•</span>
                    <span data-id="element-82">Dokumentierte Checklisten für IT-Prozesse</span>
                  </li>
                  <li className="flex items-start" data-id="element-83">
                    <span className="text-blue-600 mr-2" data-id="element-84">•</span>
                    <span data-id="element-85">
                      Jährliche IT-Sicherheitsschulungen für alle Mitarbeitenden
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-86">
                    <span className="text-blue-600 mr-2" data-id="element-87">•</span>
                    <span data-id="element-88">
                      Sensibilisierung der Praxisleitung für
                      Informationssicherheit
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Patch- & Änderungsmanagement */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-89">
            <div className="p-6" data-id="element-90">
              <div className="flex items-center" data-id="element-91">
                <div className="flex-shrink-0" data-id="element-92">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600" data-id="element-93">
                    <ServerIcon className="h-6 w-6" data-id="element-94" />
                  </div>
                </div>
                <h3 className="ml-4 text-xl font-medium text-gray-900" data-id="element-95">
                  Patch- & Änderungsmanagement
                </h3>
              </div>
              <div className="mt-4 text-gray-600" data-id="element-96">
                <ul className="space-y-3" data-id="element-97">
                  <li className="flex items-start" data-id="element-98">
                    <span className="text-blue-600 mr-2" data-id="element-99">•</span>
                    <span data-id="element-100">
                      Pflicht zu regelmäßigen Sicherheitsupdates (A1-14 bis
                      A1-17)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-101">
                    <span className="text-blue-600 mr-2" data-id="element-102">•</span>
                    <span data-id="element-103">
                      Veraltete Systeme dürfen nicht mehr betrieben werden
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-104">
                    <span className="text-blue-600 mr-2" data-id="element-105">•</span>
                    <span data-id="element-106">
                      Trennung oder Ausmusterung nicht mehr unterstützter
                      Software
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-107">
                    <span className="text-blue-600 mr-2" data-id="element-108">•</span>
                    <span data-id="element-109">
                      Dokumentiertes Änderungsmanagement für alle IT-Systeme
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Datensicherung & Endgeräte */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-110">
            <div className="p-6" data-id="element-111">
              <div className="flex items-center" data-id="element-112">
                <div className="flex-shrink-0" data-id="element-113">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600" data-id="element-114">
                    <HardDriveIcon className="h-6 w-6" data-id="element-115" />
                  </div>
                </div>
                <h3 className="ml-4 text-xl font-medium text-gray-900" data-id="element-116">
                  Datensicherung & Endgeräte
                </h3>
              </div>
              <div className="mt-4 text-gray-600" data-id="element-117">
                <ul className="space-y-3" data-id="element-118">
                  <li className="flex items-start" data-id="element-119">
                    <span className="text-blue-600 mr-2" data-id="element-120">•</span>
                    <span data-id="element-121">
                      Backups müssen verschlüsselt, regelmäßig getestet und
                      zugriffsgeschützt sein (A1-22 bis A1-25)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-122">
                    <span className="text-blue-600 mr-2" data-id="element-123">•</span>
                    <span data-id="element-124">
                      Verantwortlichkeiten für Datensicherungen klar
                      dokumentieren
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-125">
                    <span className="text-blue-600 mr-2" data-id="element-126">•</span>
                    <span data-id="element-127">Sichere Konfiguration aller Endgeräte</span>
                  </li>
                  <li className="flex items-start" data-id="element-128">
                    <span className="text-blue-600 mr-2" data-id="element-129">•</span>
                    <span data-id="element-130">
                      Regelmäßige Überprüfung der Wiederherstellbarkeit von
                      Backups
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* E-Mail & Cloud */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-131">
            <div className="p-6" data-id="element-132">
              <div className="flex items-center" data-id="element-133">
                <div className="flex-shrink-0" data-id="element-134">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600" data-id="element-135">
                    <MailIcon className="h-6 w-6" data-id="element-136" />
                  </div>
                </div>
                <h3 className="ml-4 text-xl font-medium text-gray-900" data-id="element-137">
                  E-Mail & Cloud
                </h3>
              </div>
              <div className="mt-4 text-gray-600" data-id="element-138">
                <ul className="space-y-3" data-id="element-139">
                  <li className="flex items-start" data-id="element-140">
                    <span className="text-blue-600 mr-2" data-id="element-141">•</span>
                    <span data-id="element-142">
                      E-Mail-Clients: HTML-Interpretation deaktivieren,
                      Transportverschlüsselung erzwingen (A1-40)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-143">
                    <span className="text-blue-600 mr-2" data-id="element-144">•</span>
                    <span data-id="element-145">
                      Cloud-Dienste dürfen nur mit aktuellem C5-Testat (§ 393
                      SGB V) verwendet werden (A1-50)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-146">
                    <span className="text-blue-600 mr-2" data-id="element-147">•</span>
                    <span data-id="element-148">
                      Überprüfung aller verwendeten Cloud-Dienste auf
                      Konformität
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-149">
                    <span className="text-blue-600 mr-2" data-id="element-150">•</span>
                    <span data-id="element-151">Sichere Konfiguration der E-Mail-Kommunikation</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Großpraxen-Zusatzpflichten */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-152">
            <div className="p-6" data-id="element-153">
              <div className="flex items-center" data-id="element-154">
                <div className="flex-shrink-0" data-id="element-155">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600" data-id="element-156">
                    <NetworkIcon className="h-6 w-6" data-id="element-157" />
                  </div>
                </div>
                <h3 className="ml-4 text-xl font-medium text-gray-900" data-id="element-158">
                  Großpraxen-Zusatzpflichten
                </h3>
              </div>
              <div className="mt-4 text-gray-600" data-id="element-159">
                <ul className="space-y-3" data-id="element-160">
                  <li className="flex items-start" data-id="element-161">
                    <span className="text-blue-600 mr-2" data-id="element-162">•</span>
                    <span data-id="element-163">
                      Netzwerksegmentierung (Praxis-, Büro-, Gäste-WLAN)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-164">
                    <span className="text-blue-600 mr-2" data-id="element-165">•</span>
                    <span data-id="element-166">
                      Regelmäßiges Monitoring & E-Mail-Archivierung (A3-16 bis
                      A3-17)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-167">
                    <span className="text-blue-600 mr-2" data-id="element-168">•</span>
                    <span data-id="element-169">
                      Erhöhte Anforderungen an Dokumentation und Überprüfung
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-170">
                    <span className="text-blue-600 mr-2" data-id="element-171">•</span>
                    <span data-id="element-172">
                      Erweitertes Berechtigungsmanagement für Mitarbeitende
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-173">
          <a href="#angebot" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-174">
            Wie wir Sie unterstützen können
          </a>
        </div>
      </div>
    </section>;
}